<template>
  <div>
    <el-dialog custom-class="editor-dialog" :center="center" :close-on-click-modal="closeOnClickModal" :width="width" :visible="dialogVisible" top="8vh"
      :z-index="2000" :before-close="handleClose" @open="onDialogOpen">
      <template #title>
        <span>{{editorTitle}}</span>
      </template>
      <div class="backgroud-white cs-editor-content">
        <el-form key="form" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :rules="rules" :model="model" label-width="100px">
          <el-form-item label="部门名称" prop="label">
            <el-input placeholder="请输入部门名称" :disabled="readonly" v-model="model.label" class="input-width" />
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <div class="dialog-footer popup-footer">
          <el-row>
            <el-col>
              <el-button v-if="!readonly" :disabled="isSaving" :loading="isSaving" type="primary" @click="saveChanges">保存</el-button>
            </el-col>
          </el-row>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { OrgChartNode } from "./orgChartNode";
import { saveDepartment } from "@/service/oganization.service";

const mixin_general = {
  methods: {
    validate() {
      let isValid = true;

      let refForm = this.$vueRefStore.getChildrenRef("form");
      if (!!refForm) {
        refForm.validate((valid) => {
          isValid = valid;
        });
      }

      return isValid;
    },
  },
};

const default_modelData = {
  dataId: 0,
  nodeType: 1,
  parentDataId: 0,
  parentNodeType: 1,
  label: null,
  nodeType: 1,
};

export default {
  name: "orgDepartmentNodeEditor",
  mixins: [mixin_general],
  props: {
    center: {
      type: Boolean,
      default: true,
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "35%",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    parentNode: Object,
    data: Object,
  },
  model: {
    prop: "visible",
    event: "visibleChange",
  },
  data() {
    return {
      isSaving: false,
      dialogVisible: false,
      rules: {
        label: [
          {
            required: true,
            message: "请输入部门名称",
            trigger: "blur",
          },
          {
            max: 250,
            message: "部门名称不可超过250个字符",
            trigger: "blur",
          },
        ],
      },
      model: Object.clone(default_modelData),
    };
  },
  created() {
    this.reloadVisible();
  },
  computed: {
    editorTitle() {
      if (this.readonly)
        return "查看部门";

      if (!!this.model.dataId)
        return "编辑部门";

      return "新增部门";
    }
  },
  methods: {
    async saveDepartmentToServer() {
      try {
        let data = {
          Id: this.model.dataId,
          Name: this.model.label,
          ParentId: this.model.parentDataId,
        };
        let result = await saveDepartment(data);
        if (!!result && result.success) {
          this.model.dataId = result.data;
          this.$message.success("保存成功");
          return true;
        } else {
          if (result.message){
            this.$message.error(result.message);
          }else{
            this.$message.error("保存失败");
          }
          
        }
      } catch (error) {
        console.error(error);
      }

      return false;
    },

    reloadVisible(newValue = this.visible) {
      if (this.dialogVisible === newValue) return;

      this.dialogVisible = newValue;
      if (this.dialogVisible) this.reloadDataFromProps();
    },
    resetData() {
      this.model = Object.clone(default_modelData);
    },
    async reloadDataFromProps() {
      if (!this.dialogVisible) return;

      let newModel = Object.clone(default_modelData);
      if (!!this.data) {
        newModel.dataId = this.data.dataId;
        newModel.nodeType = this.data.nodeType;
        newModel.parentDataId = this.data.parentDataId;
        newModel.parentNodeType = this.data.parentNodeType;
        newModel.label = this.data.label;
      } else {
        newModel.parentDataId = this.parentNode.dataId;
        newModel.parentNodeType = this.parentNode.nodeType;
      }

      this.model = newModel;
      let refForm = this.$vueRefStore.getChildrenRef("form");
      if (!!refForm) {
        refForm.resetFields();
      }
    },
    showDialog() {
      this.dialogVisible = true;
      this.$emit("visibleChange", this.dialogVisible);
    },
    closeDialog() {
      this.dialogVisible = false;
      this.$emit("visibleChange", this.dialogVisible);
    },
    onDialogOpen() {
      this.reloadDataFromProps();
    },
    handleClose(done) {
      this.$nextTick(async () => {
        this.resetData();

        this.closeDialog();
      });
    },
    saveChanges() {
      let isValid = this.validate();
      if (!isValid) return;

      this.$nextTick(async () => {
        let result = await this.saveDepartmentToServer();
        if (result) {
          let node = this.data;
          if (!node) {
            node = this._getNodeFromModel();

            if (!this.parentNode.children)
              this.$set(this.parentNode, "children", []);

            this.parentNode.childrenDepartment.push(node);

            if (!this.parentNode.expand)
              this.$set(this.parentNode, "expand", true);
          } else {
            node = this._getNodeFromModel(node);
          }

          this.closeDialog();
        }
      });
    },
    _getNodeFromModel(node = null) {
      if (!node) {
        node = OrgChartNode.createPersonnelNode(this.parentNode);
      }

      node.dataId = this.model.dataId;
      node.nodeType = this.model.nodeType;
      node.parentDataId = this.model.parentDataId;
      node.parentNodeType = this.model.parentNodeType;
      node.label = this.model.label;

      return node;
    },
  },
  watch: {
    visible(newValue) {
      this.reloadVisible(newValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-dialog__wrapper {
  /deep/ .editor-dialog {
    min-width: 400px;

    .el-dialog__header {
      font-size: 1.75em;
      font-weight: bold;
    }
  }
}

.cs-editor-content {
  padding: 0 15%;
  overflow-y: auto;

  .el-form-item {
    margin-bottom: 12px;

    .input-width {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/orgChart/orgDepartmentNodeEditor.vue